// Used to set the item's heights when vitualization is used
export enum Heights {
    MainCat = 64,
    SubCat = 48,
    Prod = 154,
    WithoutImage = 100
}